export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10822.30ff5538.jpg";